export const filterVisibleColumns = <
  T extends { defaultVisible?: boolean; visible?: boolean },
>(
  columns: T[]
): T[] => columns.filter(col => col.visible !== false);
